export class RealTimeOrderRecordingIsNotLive extends Error {
  constructor() {
    super('Real-Time recording for this order is not live')
    Object.setPrototypeOf(this, RealTimeOrderRecordingIsNotLive.prototype)
  }
}
